// zh_CN language file
// Generated from Feishu Bitable
// Total entries: 402

export default{
    "game_diamond": {
        "title": "游戏钻说明",
        "title0_title": "如何获得游戏钻",
        "title0": {
            "txt1": "1. 您可以通过特定的任务/活动获得游戏钻。",
            "txt2": "2. 游戏钻无法通过充值获得。"
        },
        "title1_title": "游戏钻的用途",
        "title1": {
            "txt1": "1. 游戏钻只能用于玩游戏。",
            "txt2": "2. 在游戏内，游戏钻等同于普通钻石，可以直接使用。用游戏钻，赢取的钻石为普通钻。",
            "txt3": "3. 游戏内消耗钻石时，优先消耗游戏钻。",
            "txt4": "4. 游戏钻可以和钻石同时使用。如，已有200游戏钻和800钻石，游戏内消耗1000钻，会一次消耗掉200游戏钻和800钻。"
        },
        "title2_title": "游戏钻的有效期",
        "title2": {
            "txt1": "1. 游戏钻在获得时会有有效天数，过期后系统会进行回收。"
        }
    },
    "guanxi_gift_rule_title": "礼物说明",
    "guanxi_gift_rule_1": "赠送关系礼物后，对方可选择是否与你成为关系。双方之间只能存在一种关系。",
    "guanxi_gift_rule_2": "每人最多有3个关系，关系类型可以相同。",
    "guanxi_gift_rule_3": "成为关系24小时后可以解除关系。解除关系24小时候可再次成为关系",
    "not_exist": "未找到",
    "mbti_intro_title": "MBTI 说明",
    "mbti_intro_pers": "性格特点",
    "mbti_intro_love": "恋爱特点",
    "mbti_intro_istj_pers": "检查员型人格",
    "mbti_intro_istj_feature": "严肃、安静、注重细节和准确性，喜欢有秩序和有组织的生活。他们责任心强，可靠，善于遵循规则和传统。",
    "mbti_intro_istj_love": "在恋爱中，ISTJ 会是一个忠诚、稳定的伴侣。他们会认真对待感情，注重承诺和责任，愿意为对方付出实际的行动。但可能不太善于表达情感，需要时间来建立深度的情感连接。",
    "mbti_intro_isfj_pers": "照顾者型人格",
    "mbti_intro_isfj_feature": "温柔、体贴、善良，有很强的同情心和耐心。他们注重细节，善于照顾他人的需求，是很好的倾听者和支持者。",
    "mbti_intro_isfj_love": "ISFJ在恋爱中会全身心地关注对方，关心对方的生活细节，善于营造温馨、舒适的恋爱氛围。他们比较传统和保守，可能需要较长时间来确定恋爱关系，但一旦确定，就会非常忠诚。",
    "mbti_intro_infj_pers": "建筑师型人格",
    "mbti_intro_infj_feature": "富有洞察力和创造力，对人性和未来有深刻的理解。他们内心世界丰富，情感深沉，善于思考和分析。",
    "mbti_intro_infj_love": "INFJ在寻找伴侣时，更注重精神上的共鸣和契合。他们渴望与伴侣进行深入的思想交流，对爱情有着很高的理想和期待。一旦陷入爱河，会非常专注和深情。",
    "mbti_intro_intj_pers": "指挥官型人格",
    "mbti_intro_intj_feature": "理性、冷静、自信，具有很强的逻辑分析能力和决策能力。他们追求知识和智慧，对自己的目标有着坚定的追求。",
    "mbti_intro_intj_love": "INTJ 在恋爱中会以理性的方式对待感情，注重双方的价值观和目标是否一致。他们可能不会轻易表达情感，但会通过实际行动来表达对伴侣的关心和支持。",
    "mbti_intro_istp_pers": "工匠型人格",
    "mbti_intro_istp_feature": "冷静、实际、善于观察和分析。他们喜欢动手操作，解决实际问题，对机械和技术有着浓厚的兴趣。",
    "mbti_intro_istp_love": "ISTP 在恋爱中比较随性和自由，不喜欢受到过多的约束。他们注重当下的感受和体验，会与伴侣一起享受生活中的乐趣。",
    "mbti_intro_isfp_pers": "艺术家型人格",
    "mbti_intro_isfp_feature": "敏感、温柔、富有艺术气质。他们注重内心的感受和情感体验，善于用艺术的方式表达自己。",
    "mbti_intro_isfp_love": "ISFP 在恋爱中会非常浪漫和体贴，善于营造浪漫的氛围，给对方带来惊喜和感动。他们比较情绪化，需要伴侣的理解和包容。",
    "mbti_intro_infp_pers": "调停者型人格",
    "mbti_intro_infp_feature": "理想主义、善良、富有同情心，内心世界丰富而敏感。他们追求和谐与美好，对人性有着深刻的理解和信任。",
    "mbti_intro_infp_love": "INFP 在恋爱中会全身心地投入，渴望与伴侣建立深厚的情感连接。他们注重情感的交流和共鸣，对爱情有着美好的憧憬和期待。",
    "mbti_intro_intp_pers": "逻辑学家型人格",
    "mbti_intro_intp_feature": "理性、冷静、善于思考和分析。他们对知识有着强烈的渴望，喜欢探索未知的领域，追求真理和智慧。",
    "mbti_intro_intp_love": "INTP 在恋爱中会以理性的方式对待感情，注重双方的思想交流和精神契合。他们可能不会轻易表达情感，但会通过理性的分析和讨论来加深对彼此的了解。",
    "mbti_intro_estp_pers": "企业家型人格",
    "mbti_intro_estp_feature": "热情、外向、乐观，喜欢与人交往和冒险。他们具有很强的现实感和行动力，善于把握机会。",
    "mbti_intro_estp_love": "ESTP 在恋爱中充满活力和热情，喜欢与伴侣一起尝试新的事物，享受生活的乐趣。他们比较直接和坦率，会大胆地表达自己的情感和想法。",
    "mbti_intro_esfp_pers": "表演者型人格",
    "mbti_intro_esfp_feature": "外向、乐观、热情，喜欢与人交往和娱乐。他们具有很强的表现力和感染力，善于制造欢乐和氛围。",
    "mbti_intro_esfp_love": "ESFP 在恋爱中会是一个充满活力和乐趣的伴侣，喜欢与对方一起参加各种社交活动和娱乐项目。他们注重当下的感受和体验，会给对方带来很多快乐和惊喜。",
    "mbti_intro_enfp_pers": "小太阳型人格",
    "mbti_intro_enfp_feature": "热情、乐观、富有创造力，充满活力和好奇心。他们善于与人交往，能够很好地理解和感受他人的情感。",
    "mbti_intro_enfp_love": "ENFP 在恋爱中会像小太阳一样，给对方带来温暖和快乐。他们充满浪漫和幻想，喜欢与伴侣一起创造美好的回忆。他们对爱情充满热情，会积极地表达自己的情感。",
    "mbti_intro_entp_pers": "辩论家型人格",
    "mbti_intro_entp_feature": "聪明、机智、善于思考和辩论。他们具有很强的好奇心和求知欲，喜欢探索新的事物和思想。",
    "mbti_intro_entp_love": "ENTP 在恋爱中会与伴侣进行深入的思想交流和辩论，他们喜欢挑战和被挑战，希望通过这种方式来加深对彼此的了解。他们可能会比较调皮和幽默，给恋爱生活带来很多乐趣。",
    "mbti_intro_estj_pers": "总经理型人格",
    "mbti_intro_estj_feature": "实际、果断、自信，具有很强的组织能力和领导能力。他们注重效率和结果，喜欢按照计划行事。",
    "mbti_intro_estj_love": "- ESTJ 在恋爱中会比较主动和强势，他们会积极地追求自己喜欢的人，并努力为双方的未来规划和努力。他们注重实际行动，会通过物质和实际的帮助来表达对伴侣的关心和爱。",
    "mbti_intro_esfj_pers": "执政官型人格",
    "mbti_intro_esfj_feature": "热情、友好、善于照顾他人，具有很强的社交能力和组织能力。他们注重传统和家庭，喜欢与人建立深厚的情感联系。",
    "mbti_intro_esfj_love": "ESFJ 在恋爱中会非常体贴和关心对方，善于营造温馨、和谐的恋爱氛围。他们比较传统和保守，会遵循传统的恋爱方式和礼仪，注重家庭和社会的认可。",
    "mbti_intro_enfj_pers": "主人公型人格",
    "mbti_intro_enfj_feature": "热情、自信、富有领导力，善于与人交往和沟通。他们具有很强的洞察力和感染力，能够很好地理解和引导他人。",
    "mbti_intro_enfj_love": "ENFJ 在恋爱中会是一个热情、浪漫的伴侣，他们善于表达自己的情感，会给对方带来很多温暖和感动。他们注重双方的情感交流和共鸣，希望与伴侣建立深厚的情感连接。",
    "mbti_intro_entj_pers": "指挥官型人格",
    "mbti_intro_entj_feature": "理性、果断、自信，具有很强的领导能力和决策能力。他们追求卓越和成功，对自己和他人都有着很高的要求。",
    "mbti_intro_entj_love": "ENTJ 在恋爱中会以理性和目标为导向，他们会选择与自己志同道合、能够共同成长和进步的伴侣。他们注重双方的能力和素质，会通过共同的事业和目标来加深彼此的感情。",
    "expressProposalWall": "表白墙",
    "expressHowTo": "如何登上表白墙",
    "expressSend": "将表白礼物送给你的爱人，你的爱意文字将显示在表白墙上。",
    "expressSend1": "1.点击“立即表白”，进入活动页面，选择你要表白的对象。",
    "expressSend2": "2.选择礼物并在卡片上输入你想对他说/她的话。",
    "expressSend3": "3.点击发送礼物，你的表白卡片将展示在表白墙上。",
    "expressDifferent": "表白礼物种类",
    "expressWeHave": "我们提供以下四种表白礼物：",
    "expressWeHave1": "1.基础表白礼物卡：简单的纯色背景。",
    "expressWeHave2": "2.装饰表白礼物卡：多彩装饰背景。",
    "expressWeHave3": "3.豪华表白礼物卡：带有奢华效果的装饰背景。",
    "expressWeHave4": "4.真爱表白礼物卡：带有奢华效果的装饰背景，并伴有全服广播。",
    "expressProposal": "表白卡片展示范围",
    "expressProposal1": "1.房间内的表白墙。（点击表白礼物上方的条）",
    "expressProposal2": "2.动态页面旁的表白墙。",
    "diamondDrop1": "1.当房间内用户每单次送礼总额超过50000钻石（幸运礼物按照实际钻价*0.1计算），房间内则会掉落1个钻石宝箱，所有用户都可开启宝箱抢得钻石。",
    "diamondDrop2": "2.每个宝箱在开启前有1分钟的等待时间。",
    "diamondDrop3": "3.每个宝箱钻石数量有限，宝箱开启倒计时结束后，则不可再领取该宝箱内钻石。",
    "diamondDrop4": "4.宝箱结束后可点击查看在该宝箱内抢得的钻石。",
    "baoxaingxianding": "宝箱限定",
    "cancelAccount": {
        "accountRecoveryContent": "在恢复期间，您可以使用账号之前的登录方式重新登录并选择恢复账号。一旦账号恢复，您将能够继续访问您的账号，包括所有保存的消息、等级和货币资产等。",
        "accountRecoveryTitle": "账号恢复：",
        "confirmCancellation": "您仍然要注销帐号吗？",
        "convalescenceContent": "注销申请提交后的30天内，尽管账号将被暂时停用，但我们会保留您账号内的所有信息、等级、货币资产等数据，以便在您决定恢复账号时，一切如故。",
        "convalescenceTitle": "恢复期：",
        "finalContent": "如果在恢复期结束时（即从提交注销申请之日起的第31天），您没有选择恢复账号，您的账号及其所有数据将被永久删除。请注意，一旦账号被永久删除，将无法恢复，所有相关数据也将不可逆转地丢失。",
        "finalTitle": "最终注销：",
        "reserveContent": "在恢复期间，我们将保护您的账号数据安全，确保数据不会在恢复期间遗失或受损。",
        "reserveTitle": "数据保留：",
        "statementContent": "注销申请：当您提交账号注销申请后，您的账号将进入30天的“恢复期”。在此期间您可以随时选择恢复账号。如果您加入公会，将不可进行帐号注销",
        "statementTitle": "账号注销声明：",
        "userContent": "感谢您使用我们的服务。我们理解，有时您可能需要做出注销账号的决定。为确保您的选择是经过深思熟虑的，并为您提供可能的反悔机会，我们特此说明账号注销流程及相关条款。",
        "userTitle": "尊敬的用户："
    },
    "Countdown": "倒计时",
    "Endactivity": "活动已经结束",
    "eventDetails": "活动详情",
    "eventGifts": "活动礼物",
    "eventList": "活动榜单",
    "eventReward": "活动奖励",
    "eventRewards": {
        "player": "当日活跃玩家",
        "proportion": "返奖比例",
        "title": "活动返奖",
        "txt1": "1. 每天0点(UTC+8)计算昨日的数据。",
        "txt2": "2. 根据房间内参与的人数和房间内实际消耗的钻石（用户下注钻石-用户获得钻石）进行返奖。",
        "txt3": "3. 每周一0点(UTC+8)计算上周数据，奖励将在3日内下发。",
        "txt4": "4. 返奖比例：",
        "txt5": "5. 活跃玩家定义：当日累计下注超过1000钻。"
    },
    "EventRules": "活动规则",
    "Eventtime": "活动时间",
    "guild": {
        "guild_certification01": "公会认证",
        "guild_certification02": "欢迎娱乐公会入驻",
        "guild_certification03": "招募要求",
        "guild_certification04": [
            "一周内完成10名签约主播并入驻",
            "能提供公会长身份证等实名证件",
            "提供公会简介、团队介绍、主播资料、主播收益规则等"
        ],
        "guild_certification05": "满足以上条件，发送资料到官方认证邮箱中：billionairepte@gmail.com审核通过后会有专员与您联系",
        "guild_certification06": "已复制到剪切板",
        "guild_certification07": "入驻咨询方式",
        "guild_certification08": "复制",
        "guild_certification09": "入会须知",
        "guild_certification10": [
            {
                "title": "1. 入会规则",
                "value": [
                    "申请人与公会长协商一致，在平台内发起入会申请，会长审核通过后，则成为公会签约主播，产生公会贡献"
                ]
            },
            {
                "title": "2. 退会规则",
                "value": [
                    "入会成功后若要退会，主播需要与会长协商一致，在公会资料页点击【退出公会】，会长点击【同意退会】后，成员将立即退出公会。",
                    "退会成功后可再申请加入其他公会。"
                ]
            }
        ],
        "guild_certification11": "公会说明",
        "guild_certification12": [
            {
                "title": "公会收入",
                "value": [
                    "1.家族房里的用户和主播领取礼品，生成公会贡献",
                    "2.家族房里进行boss攻击",
                    "3.公会签约的主播创建cp房间，领取礼物产生公会贡献（加入家族后，未签约的主播无法创建cp房间产生家族贡献）"
                ]
            }
        ],
        "InvitationCodeTitle": "邀请码",
        "invite_rules_intriduction": "邀请规则介绍",
        "invite_rules_intriduction_content": [
            "1.主播可以通过注册时填写邀请码直接申请加入你的公会，并且成为主播",
            "2.未填写邀请码注册的主播，可以再通过进入家族页面申请加入你的家族，之后再申请成为主播"
        ]
    },
    "legend": {
        "title": "传奇二月"
    },
    "officialMember": "官方人员",
    "prettyNumber": {
        "text": "Ⅰ. 领取靓号",
        "text1": "1. 成为贵族3及以上后可以领取1个对应等级的靓号。",
        "text2": "2. 高等级的贵族可以领取一个低等级的靓号。如贵族6可以领取一个LV3的靓号。",
        "text3": "1. 贵族到期之后，靓号也同时不可使用，需要激活贵族才可继续使用靓号。",
        "text5": "1. 一旦领取了一个靓号，不可以更换成同等级及以下的靓号",
        "text6": "2. 靓号使用期间获得更高等级的贵族，可以立刻更换一个高等级的靓号，同时原靓号会进入商城。",
        "text7": "3. 例如，一个贵族4的用户首先领取了一个贵族4的靓号，之后用户又升级为了贵族6，则用户不能更换为贵族4及以下的靓号，但是可以立刻领取一个贵族6的靓号。",
        "title": "说明",
        "title1": "Ⅱ. 靓号到期",
        "title2": "Ⅲ. 靓号更换"
    },
    "reception": {
        "reception01": "收礼榜说明",
        "reception02": [
            {
                "title": "1.什么是房间收礼榜单？",
                "value": [
                    "房间收礼榜是房间收礼数的实时榜单",
                    "房间收礼数=钻石收礼数"
                ]
            },
            {
                "title": "2.房间收礼榜如何排序？",
                "value": [
                    "根据所有房间的收入，通过综合计算进行排序",
                    "小时榜：UMT+8时区，每一小时刷新重置",
                    "日榜：UMT+8时区，第二天0点刷新重置"
                ]
            },
            {
                "title": "3.小时榜Top1，全服推送",
                "value": [
                    "房间收礼小时榜Top1，在全服房间中进行"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "返回",
        "event_rule": "<p>1. 时长榜：统计活动期间房间内用户在所有麦位上累计在麦时长，最终榜单Top3房间贡献麦时最高3人获得奖励；</p><p>2. 豪气榜：统计活动时间房间内累计收到的钻石数，最终榜单Top3房间中每个房间消耗钻石最高的3人获得奖；</p><p>3. 本活动为周循环活动，每周榜单会重新进行统计。</p>",
        "last_week": "上周",
        "last_week_rank": "上周榜单详细",
        "reward": "奖励",
        "rich_rank": "房间收礼榜",
        "rule": "规则",
        "rule_reward": "规则&奖励",
        "time_rank": "时长榜",
        "title": "家族房",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "头像框14天",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png?t=1666610955",
        "top1_pictures_2_name": "入场特效14天",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "头像框14天",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "头像框7天",
        "top2": "TOP2",
        "top3": "TOP3"
    },
    "TopUpRewards": "充值奖励",
    "treasure_chest": {
        "title": "宝箱礼物说明",
        "value1": "1. 宝箱礼物分为木宝箱、银宝箱、金宝箱。",
        "value2": "2. 打开宝箱后，将随机从宝箱中获得一个礼物并送出。",
        "value3": "3. 送礼方根据消耗的钻石数获得经验值，收礼方根据宝箱开出的礼物，获得对应价值的Pocket币和魅力值。",
        "value4": "4. 木宝箱，单价1500钻石，可以开出的礼物：",
        "value5": "5. 银宝箱，单价7500钻石，可开出礼物：",
        "value6": "6. 金宝箱 单价 25000钻石，可开出礼物：",
        "value7": "7. 宝箱礼物仅供娱乐交流，任何影响公平性、利用产品Bug等不正当手段参与的行动将被禁止。平台一经发现将做封号处理，并保留一切追究法律责任的权利。"
    },
    "treasure_name": {
        "name1": "木宝箱",
        "name2": "银宝箱",
        "name3": "金宝箱",
        "name4": "概率"
    },
    "Value": "价值：",
    "Webname": {
        "addUid": "新增UID",
        "balance": "余额：",
        "Confirm": "确认",
        "err_uid": "UID错误，请重新输入",
        "lang": "选择语言",
        "Query": "查询",
        "recharge": "充值中心",
        "Recharge": "充值",
        "self": "渠道",
        "uid": "更换UID",
        "uuserName": "用户昵称：",
        "Withdrawal": "提现"
    },
    "Weekly_Cp": {
        "7days": "7天",
        "back": "返回",
        "countdown": "本周倒计时",
        "day": "天",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>注意事项</p><p>1.所有奖励将于活动结束后3~5个工作日内发放至您的账户.</p><p>2.榜单统计范围为用户向其他用户赠送活动礼物所消耗的钻石，1钻石=1CP值，CP值最高的3组CP组合可获得活动奖励；</p><p>3.每周一0点(UTC+8)结束，并结算上周的值</p><p>4.幸运礼物仅计算10%的钻石。</p>",
        "gift": "活动礼物",
        "hour": "小时",
        "last_week": "上周",
        "last_week_rank": "上周榜单详情",
        "minute": "分钟",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "奖励",
        "rule": "规则",
        "rule_reward": "规则&奖励",
        "seconds": "秒",
        "title": "Soulmate",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "周星头像框",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "最佳助力头像框",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "周星套装",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "TOP2",
        "top2_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "TOP3",
        "top3_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "TOP 4-6",
        "top710": "TOP7-10"
    },
    "Withdrawal": "提现说明",
    "withdrawalInstructions": {
        "text1": "1. 提现功能当前仅部分国家。",
        "text2": "2. 提现到账时间会因渠道而异。",
        "text3": "3. 提现实际到账金额会受汇率变化，手续费等影响，比展示金额略低。",
        "text4": "4. 每天仅能提现1次。",
        "text5": "5. 如果你遇到任何问题， <span>请联系我们</span>。"
    },
    "withdrawalLogin": {
        "accountId": "Pix账户ID",
        "accountIdTips": "",
        "accountIdtsa": "Pix账户ID不能为空",
        "accountType": "Pix账户类型",
        "code": "验证码：",
        "Confirm": "确认",
        "documentId": "个人身份证号码",
        "documentIdTips": "",
        "documentIdtsa": "身份证(ID)类型不能为空",
        "documentType": "身份证类型",
        "getAccount": "获取账号",
        "getUserId": "请输入用户id",
        "incorrectAccount": "账号不正确",
        "login": "登录",
        "loginSuccessful": "登录成功",
        "name": "Pix用户名",
        "nameTips": "",
        "nametsa": "长度需在5到100之间",
        "officialGroup": "如果有任何疑问，请联系官方人员。",
        "pocket": "Pocket币余额",
        "Pocket": "Pocket币余额不足",
        "Send": "发送",
        "text": "验证码将发送到App内",
        "title": "收益提现",
        "title2": "提现详情",
        "user_id": "账号ID：",
        "Whatsapp": "Whatsapp账号不正确",
        "WhatsappTips": "",
        "applicationTime": "申请日期",
        "amount": "提现金额",
        "success": "成功",
        "applicationSuccess": "申请成功"
    },
    "top1AnchorRewards": "Top1主播奖励",
    "top2_3AnchorRewards": "Top2-3主播奖励",
    "top4_10AnchorRewards": "Top4-10主播奖励",
    "top1Icon7day": "头框*7天",
    "top1_2Icon7day": "入场特效*7天",
    "top3Icon7day": "头框*7天",
    "top1VIPRewards": "Top1充值奖励",
    "top2_3VIPRewards": "Top2-3充值奖励",
    "top4_10VIPRewards": "Top4-10充值奖励",
    "relastionship": {
        "des": [
            "",
            "1. 赠送关系礼物后，对方可选择是否与你建立关系。双方之间只能存在一种关系。",
            "2. 在建立关系后的7个自然日（UTC+3）内，关系亲密值不发生衰减。在过了关系保护期之后，一个自然日内，关系亲密值没有上升50度，则在次日0点衰减当前关系亲密值的10%，关系亲密值最小衰减为1。当关系亲密值衰减为0时，在次日0点解除绑定关系 。 当连续10天关系亲密值没有上升50度，则在次日点0点自动解除关系",
            "3. 成为关系24小时后可以解除关系。解除关系24小时后可再次成为关系",
            "4. 每人默认有3个关系位置，你可花费钻石购买关系位置，关系位价格为99999钻石/个，最多可以购买10个关系位。你也可以通过提升你的VIP等级来增加你的关系位置。",
            "VIP等级",
            "共可扩展关系位"
        ]
    },
    "gift_album_des1": "赠送以上礼物可帮助他/她点亮 周图鉴-《环游世界》并获得奖励",
    "gift_album_des2": "赠送以上礼物可帮助他/她点亮 永久图鉴-《心动焦点》并获得奖励",
    "gift_album_des3": "赠送以上礼物可帮助他/她点亮 永久图鉴-《SVIP的守护》并获得奖励",
    "gift_album_des4": "赠送以上礼物可帮助他/她点亮 永久图鉴-《梦中的婚礼》并获得奖励",
    "gift_album_des5": "前往【个人主页】-【礼物墙】-【图鉴】查看详情",
    "gift_harifata": "哈利法塔",
    "gift_sailing_hotel": "帆船酒店",
    "gift_mosque": "大清真寺",
    "gift_abatta": "阿巴特塔",
    "gift_sphinx": "狮身人面像",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "心动信号",
    "gift_conf_lv2": "坠入爱河",
    "gift_conf_lv3": "爱无止境",
    "gift_conf_lv4": "一生一世",
    "gift_habibi": "兄弟",
    "gift_bestie": "闺蜜",
    "gift_couple": "情侣",
    "gift_confidant": "知己",
    "weding_gift_kiss": "亲吻",
    "weding_gift_ring": "戒指",
    "weding_gift_proposal": "求婚",
    "weding_gift_castle": "城堡",
    "weding_gift_wedding_dress": "婚纱",
    "weding_gift_wedding": "婚礼",
    "gift_album_des6": "规则",
    "guild_can_with": "可提现",
    "guild_with_ing": "提现中",
    "guild_self_withdraw": "自提现",
    "guild_transfer_to_leader": "转移给公会长",
    "guild_salary_to_reseller": "薪资转Reseller",
    "guild_convert_to_diamond": "转换成钻石",
    "guild_platform_settlement": "平台结算",
    "guild_withdrawal_records": "提现记录",
    "guild_current_withdrawable_pcoin": "当前可提现P币",
    "guild_transfer_pcoin_amount": "转移P币数量",
    "guild_all": "全部",
    "guild_read_before_withdraw": "提现前请务必阅读:",
    "guild_withdraw_note_1": "1.此操作将向公会长发起申请，由公会长线下向您打款",
    "guild_withdraw_note_2": "2.请提前与会长确认好收款方式（银行卡/USTD等）。",
    "guild_min_withdraw_amount": "3.最低提现数为{n}P币",
    "guild_withdraw_note_4": "4.若会长确认已打款但您未收到钱，请保留聊天记录并",
    "guild_submit_application": "提交申请",
    "guild_withdraw_below_min": "可提现P币小于起提数",
    "guild_confirm_submit_application": "确认提交申请？",
    "guild_freeze_notice": "系统将冻结{n}P币，直至会长处理",
    "guild_communicate_with_leader": "请与会长沟通好提现渠道，并知晓打款由会长线下操作。",
    "guild_cancel": "取消",
    "guild_confirm": "确认",
    "guild_withdrawal_method": "提现方式",
    "guild_leader_withdraw": "会长提现",
    "guild_apply_time": "申请时间",
    "guild_process_time": "处理时间",
    "guild_rejection_reason": "拒绝原因",
    "guild_amount_refunded": "额度已退回",
    "guild_status_pending": "待审核",
    "guild_status_completed": "已完成",
    "guild_status_rejected": "已拒绝",
    "guild_show_last_3_months": "仅展示最近3个月的记录",
    "guild_withdrawal_question": "对提现记录有疑问？",
    "guild_contact_customer_service": "联系平台客服",
    "guild_certified_reseller": "认证Reseller",
    "guild_not_reseller_cannot_transfer": "不是Reseller无法转账",
    "guild_current_withdrawable": "当前可提现",
    "guild_transfer_amount": "转出金额",
    "guild_estimated_arrival": "预计到账",
    "guild_read_before_operation": "操作前请务必阅读",
    "guild_transfer_note_1": "1.请提前和Reseller沟通好线下打款事宜",
    "guild_transfer_note_2": "2.仅支持转账给Reseller",
    "guild_confirm_transfer": "确认转账",
    "guild_confirm_submit_transfer": "确认提交申请？",
    "guild_deduct_pcoin_receive_diamond": "你将扣除{n}P币，对方获得{m}钻石",
    "guild_communicate_with_reseller": "请与Reseller沟通好打款事宜",
    "guild_operation_success": "操作成功",
    "guild_exchange_diamond": "兑换钻石",
    "guild_current_exchangeable_pcoin": "当前可兑换P币",
    "guild_exchange": "兑换",
    "guild_exchange_success": "兑换成功",
    "guild_settlement_pcoin_amount": "结算P币数量",
    "guild_settlement_note_1": "1.请提前与运营沟通好提现方式",
    "guild_settlement_note_2": "2.付款将会在下周一统一处理",
    "guild_settlement_min_amount": "3.最低提现数{n}P币",
    "guild_application_submitted": "申请成功",
    "guild_deduct_pcoin": "你将扣除{n}P币",
    "guild_contact_service": "请与运营工作人员沟通好打款事宜。"
}
